// @ts-nocheck
/* eslint-disable */
export const messagesIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M2.5 6l8.26 6.522a2 2 0 002.48 0L21.5 6" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M7.975 14.58a.75.75 0 00-.95-1.16l.95 1.16zm-.95-1.16l-5.5 4.5.95 1.16 5.5-4.5-.95-1.16zm15.466 4.513l-7.5-6.5-.982 1.134 7.5 6.5.982-1.134z" fill="currentColor"/><rect x="1.75" y="5.75" width="20.5" height="12.5" rx="1.25" stroke="currentColor" stroke-width="1.5"/></svg>`,
  name: 'messages' as const,
};
